import { render, staticRenderFns } from "./AudioFileInput.vue?vue&type=template&id=bae5b5d4&scoped=true&"
import script from "./AudioFileInput.vue?vue&type=script&lang=js&"
export * from "./AudioFileInput.vue?vue&type=script&lang=js&"
import style0 from "./AudioFileInput.vue?vue&type=style&index=0&id=bae5b5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae5b5d4",
  null
  
)

export default component.exports